import React from "react";
import pure from "js/common/views/pure";

import { TextButton } from "js/common/views/inputs/buttons";

// NOTE: Button's `disabled` prop is not set in order to display a warning message on click when disabled
export default pure(({ isDisabled, onClick }) =>
    <TextButton type="primary" label="Plot Chart" testId="trend-plot-chart-btn" onClick={onClick} style={isDisabled ? { opacity : 0.6 } : {}} />
);
